import React, { useState } from 'react';
//ontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//style
import styles from 'src/asset/scss/style/user.mypage.module.scss'
//Hook
import useAuthHook from 'src/webapp/hooks/auth/auth.hook';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import PartnerWithdraw from '../bottomsheet/PartnerWithdraw';//회원탈퇴

export default function Button(props) {
    const { onLogoutHandler } = useAuthHook();//로그아웃

    /* =============== 우측 화살표 공통아이콘 =============== */
    const icon_right = <FontAwesomeIcon icon={['fal', 'chevron-right']} />;
    /* =============== 우측 화살표 공통아이콘 =============== */
    /* =============== 회원탈퇴 팝업오픈여부 =============== */
    const [ isOpen,setOpen ] = useState(false);
    const onDismissHandler = (value) => {
        setOpen(value);
    }
    /* =============== 회원탈퇴 팝업오픈여부 =============== */

    return (
        <>
        <Element tag={`div`} className={styles.btnArea}>
            <Element tag={`ul`}>
                <Element tag={`li`} anyprop={(e) => props.onKakao()} className={styles.isMobile}><Element tag={`label`}>고객센터</Element>{icon_right}</Element>
                <Element tag={`li`} anyprop={(e) => onLogoutHandler()} className={styles.isMobile}><Element tag={`label`}>로그아웃</Element>{icon_right}</Element>
                <Element tag={`li`} anyprop={(e) => onDismissHandler(true)} className={styles.point}><Element tag={`label`}>회원탈퇴</Element>{icon_right}</Element>
            </Element>
        </Element>
        {isOpen ? <PartnerWithdraw isOpen={isOpen} onDismiss={onDismissHandler} /> : null}
        </>
    );
}